import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';

import { Button, Form, Input } from 'antd';

import LoginWrapper from '@shared/pages/Login/LoginWrapper';

import css from './Login.module.scss';

const RecoveryPage = () => {
  const { restoreUserRecaptcha, isSending } = useOutletContext();
  const { t } = useTranslation(['login']);

  const handleSubmit = formData => {
    restoreUserRecaptcha(formData.email);
  };

  return (
    <LoginWrapper type='recover'>
      <Form className={css['LoginPage-form']} onFinish={handleSubmit}>
        <Form.Item
          colon={false}
          name='email'
          className={css['LoginPage-form-item']}
          validateFirst={true}
          rules={[
            {
              required: true,
              message: t('mailRequired'),
            },
            {
              type: 'email',
              message: t('checkMail'),
            },
          ]}
        >
          <Input placeholder={t('mail')} />
        </Form.Item>
        <Form.Item className={css['LoginPage-form-google']}>
          <Button size='large' type={'primary'} htmlType='submit' disabled={isSending}>
            {t('recovery')}
          </Button>
        </Form.Item>
      </Form>
    </LoginWrapper>
  );
};

export default RecoveryPage;
